import React from 'react'

import Header from '../components/header.js'
import Navigation from '../components/navigation.js'
import Footer from '../components/footer.js'

export default ({ location, children, data }) => {
  var hero = "techno-banner.jpg"
  var heroPosition = undefined
  if (location.pathname.indexOf("/music") === 0) {
      hero = "music.jpg"
  } else if (location.pathname.indexOf("/photos") === 0) {
      hero = "photos.jpg"
      heroPosition = "35%"
  }

return (
  <div>
    <Header metadata={data.site.siteMetadata} hero={hero} heroPosition={heroPosition}/>
    <Navigation slug={location.pathname}/>
    {children()}
    <Footer/>
  </div>
)}

export const query = graphql`
query LayoutQuery {
  site {
    siteMetadata {
      title,
      subtitle
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/layouts/index.js